<template>
  <article class="product-overlay">
    <nav class="nav is-hidden-tablet" @click.stop>
      <div class="nav__mobile-header">
        <button @click="$router.go(-1)">
          <span class="icon icon--close"></span>
        </button>
        <router-link title="Home" :to="{name: 'Intro'}" class="home-link"><logo></logo></router-link>
      </div>
    </nav>
    <div class="inner" v-if="product">
      <header class="mobile-header"><h1>{{product.title}}</h1></header>
      <section class="section left">
        <div class="inner">
          <div class="slideshow-outer">
            <slideshow v-show="slideshowVisible" :images="product.images" @imgsloaded="slideshowVisible = true"></slideshow>
            <img v-if="!slideshowVisible && preloadImg" :src="preloadImg" class="preload-img">
          </div>
        </div>
      </section>
      <section class="section right h7 nimbus-sans">
        <h2 class="description-title title-case" v-show="slideshowVisible || preloadImg">{{product.title}}</h2>
        <section v-html="product.descriptionHtml + priceHTML"></section>
        <!-- <pre>{{ product.variants[0].price.amount }}</pre> -->
        <!-- <pre>{{ product.variants[0].price.currencyCode }}</pre> -->
        <ul class="actions">
          <template v-if="cart">
            <li>
              <button @click.prevent="addToCart">ADD <span v-if="!cartItem">TO CART</span></button>
              <button v-if="cartItem" @click.prevent="updateCartItem(-1)">DEDUCT</button>
            </li>
            <li v-if="cartTotalCount > 0">
              <button @click.prevent="clear">CLEAR</button>
              <a class="checkout-btn" :href="cart.webUrl">CHECKOUT <span class="counter">{{cartTotalCount}}</span></a>
            </li>
          </template>
          <template v-else>
            <li>
              <a href="mailto:info@dovedaledesignstudio.com">ENQUIRE</a>
            </li>
          </template>
        </ul>
      </section>
    </div>
    <button class="close h9 icon-close-overlay" title="Close" @click.prevent="close"></button>
    <button class="close-mobile ui-nw-icon" @click.prevent="close"></button>
  </article>
</template>

<script>
import Vue from 'vue'
import Logo from './LogoMarque'
import Slideshow from 'components/Slideshow'
import _find from 'lodash/find'
export default {
  name: 'CollectionItem',
  props: ['id', 'products', 'preloadImg', 'collectionTitle'],
  components: {
    Logo,
    Slideshow
  },
  data () {
    return {
      slideshowVisible: false
    }
  },
  computed: {
    cart () {
      return this.$store.state.checkout
    },
    product () {
      return _find(this.products, ['handle', this.id])
    },
    // V2
    priceHTML () {
      let price = this.product.variants[0].price.amount
      // remove trailing zeros
      price = price.toString().replace(/\.?0+$/, '')
      let currency = this.product.variants[0].price.currencyCode
      return '<div class="price"><label>Price</label>' + price + ' ' + currency + '</div><div></div>'
    },
    // V1
    // priceHTML () {
    //   return '<div class="price"><label>Price</label>' + this.product.variants[0].price + '</div><div></div>'
    // },
    cartItem () {
      return _find(this.cart.lineItems, ['title', this.product.title])
    },
    cartTotalCount () {
      if (!this.cart || !this.cart.lineItems) return 0
      let total = 0
      for (var i = 0; i < this.cart.lineItems.length; i++) {
        total += this.cart.lineItems[i].quantity
      }
      return total
    }
  },
  watch: {
    product () {
      this.updateMeta()
    }
  },
  methods: {
    close () {
      if (this.$route.meta.firstPage) {
        this.$router.push({name: 'Collection', params: {slug: this.$route.params.slug}})
      } else {
        this.$router.back()
      }
    },
    addToCart (variant) {
      if (!this.cartItem) return this.$store.dispatch('addToCart', this.product.variants[0].id)
      return this.updateCartItem(1)
    },
    updateCartItem (difference) {
      if (!this.cartItem) return
      const qty = this.cartItem.quantity + difference
      this.$store.dispatch('updateCartItem', {id: this.cartItem.id, quantity: qty})
    },
    clear () {
      // clear item from cart if present
      // otherwise clear whole cart
      const items = this.cartItem ? [this.cartItem.id] : null
      return this.$store.dispatch('removeCartItems', items)
    },
    updateMeta () {
      let title = this.product && this.product.title
      if (!title) return
      title = this.collectionTitle ? title + ' – ' + this.collectionTitle : title
      Vue.updateMeta.setTitle(title)
    }
  },
  mounted () {
    this.$store.dispatch('createCheckout')
  }
}
</script>

<style lang="scss">
@import '../style/variables';
.product-overlay{
  $gttr: $gutter*3;

  background:$white;
  @include background(fixed, 100vh);
  z-index: $z-productOverlay;
  overflow-y:scroll;

  > .inner {
    padding:0 4.3801825157%;
    @include clearFloat(); 
  }

  .section {
    float: left;
    width:50%; //38.296063731%;
    padding:$gttr $gttr/2;
    text-align: left;
    .inner {
      position:relative;
    }
  }
  
  // flexbox supported
  .flexbox & {
    @media (min-width:$bkpt-mobile + 1) {
      > .inner{
        display:flex;
        justify-content:center;
        height:100vh;
        width:147vh;
        padding:$gttr 0;
        margin:0 auto;
      }
      .section {
        width:50%;
        padding-top:0;
        padding-bottom:0;
      }
      .section.left{
        text-align: right;
      }
      .section.right{
        display:flex;
        flex-direction:column;
        justify-content:space-between;
        h2, .actions{
          flex:0 1;
        }
        > section{
          flex:100 1;
          display:flex;
          flex-direction:column;
          justify-content: space-between;
        }
      }
      .slideshow-outer{
        display:inline-block;
        img{
          max-width:none;
          height:calc(100vh - #{$gttr} * 2);
        }
      }
      
      @media (max-aspect-ratio:1030/699) {
        > .inner {
          width:auto;
          padding-left:$gutter;
          padding-right:$gutter;
          .section{
            padding-left:$gutter;
            padding-right:$gutter;
          }
        }
        .slideshow{
          img{
            width:100%;
            max-height:none;
            height:auto;
          }
        }
      }
    }
  }

  table{
    width:100%;
    margin:$gutter 0;
    td {
      width:50% !important;
      float:left;
    }
    @include clearFloat();
  }

  .price {
    margin: $gutter 0;
    label{
      display:block;
    }
  }

  .actions{
    .flexbox & {
      li{
        display:flex;
        button, a{
          position:relative;
          margin-right: $gutter/2;
          &:last-child{
            margin-right:0;
          }
        }
      }
      .checkout-btn {
        display:flex;
        justify-content:space-around;
        &:before{
          content:'';
        }
      }
    }

    button, li > a {
      width:100%;
      display:block;
      text-align:center;
      margin:$gutter/2 0 0;
      padding:2em 0;
      background:$black;
      color:$white;
    }
  }

  // lines
  .description-title, 
  .price label,
  table tr:first-child td{
    padding-bottom: 0.5em;
    border-bottom: 1px solid;
    margin-bottom: 0.5em;
  }
  
  button.close {
    position:absolute;
    top:$gutter; right:$gutter;
    z-index: 10;
  }

  button.close-mobile{
    visibility:hidden;
  }
  
  .mobile-header {
    display:none;
  }

  // tablet
  @media (max-width:1024px) {
    .section.right{
      @include h8();
    }
  }

  // mobile 
  @include on_mobile () {
    padding-bottom:25vw;

    .mobile-header{
      display:block;
      padding:(250/35*16/12)*1rem 0 $gttr;
    }

    > .inner {
      display:block;
      padding:0 $gutter;
    }

    .section{
      float:none;
      width:auto;
      padding:0;
      + .section {
        margin-top: $gutter*2;
      }

      &.right{
        .description > *, .price, .actions{
          margin-bottom: $gutter*2;
        }
      }
    }

    .slideshow-outer{
      img{
        height:auto;
        width:100%;
      }
    }

    button.close{
      visibility:hidden;
    }
    button.close-mobile{
      visibility:visible;
      &:before{
        @include icon(close)
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// CollectionItem.vue?5c4b18aa